module.exports = __webpack_public_path__ + "img/avatar-s-9.0e4bddf9.jpg";